import React, { useState, useCallback, useRef, useEffect } from "react";
import { Stack, Grid, Button, Box, RadioGroup, FormControlLabel, Radio, FormLabel } from "@mui/material";
import { Print, RestoreOutlined, ViewList } from "@mui/icons-material";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import Axios from "axios";

import Sidebar from "../sidebar/sidebar";
import { companylogo } from "../../assets/images";
import { BaseUrl } from "../../Environment";
import "./PrintDocs.css";

import { LoanAgreement } from "../LoanAgreement/LoanAgreement";
import { LoanApplication } from "../LoanApplication/LoanApplication";
import { LoanSanctionLetter } from "../LoanSanctionLetter/LoanSanctionLetter";
import { DemandPromissoryNote } from "../DemandPromissoryNote/DemandPromissoryNote";
import { EmiCard } from "../EmiCard/EmiCard";
import { LoanReport } from "../LoanReport/LoanReport";
import { getSecureItem } from "../../utilsFunctions";
import { NoObjectionCertificate } from "../ClosedLoanNOC/NoObjectionCertificate";

const docTypes = [
  { label: "Loan Application Form", value: "1" },
  { label: "Loan Agreement", value: "2" },
  { label: "Loan Sanction Letter", value: "3" },
  { label: "EMI  Card", value: "4" },
  { label: "Demand Promissory Note", value: "5" },
  { label: "NOC Certificate", value: "6" },
];

const languages = [
  { label: "Tamil", value: "ta" },
  { label: "Telugu", value: "te" },
  { label: "Hindi", value: "hi" },
  { label: "Malayalam", value: "ml" },
  { label: "Kannada", value: "kn" },
  { label: "Marathi", value: "mr" },
  { label: "Gujarati", value: "gu" },
];

const languages2 = [
  { label: "English", value: "en"},
  { label: "Tamil", value: "ta" },
  { label: "Telugu", value: "te" },
  { label: "Hindi", value: "hi" },
  { label: "Malayalam", value: "ml" },
  { label: "Kannada", value: "kn" },
  { label: "Marathi", value: "mr" },
  { label: "Gujarati", value: "gu" },
];

const PrintDocs = () => {
  const loggedinUser = getSecureItem("loggedinUser");
  const countryCode = getSecureItem("country")?.code;
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const [selectedDocType, setSelectedDocType] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loanData, setLoanData] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [branchData, setBranchData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [renderedComponent, setRenderedComponent] = useState(null);
  const [pdfData, setPdfData] = useState([]);
  const [noOfLoans, setNoOfLoans] = useState(30);
  const [signatureType, setSignatureType] = useState("default");

  const getAllCustomers = async () => {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");
    let collectorId = loggedinUser?.userId;

    const headers = {
      Authorization: "Bearer " + token,
    };


    Axios.get(`${BaseUrl}/customer/getAllCustomers?name=&companyId=${companyId}&branchId=${selectedBranch?.value || ''}`, {
      headers: headers,
    })
      .then((resp) => {
        if (resp.status == 200) {
          const cList = resp.data?.map((item) => ({
            label: item?.cust_id
              ? `${item.firstName} ${item.lastName} (${item.cust_id})`
              : `${item.firstName} ${item.lastName}`,
            value: item.customerId,
          }));
          setCustomerData(cList);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLoanApplicationDetails = async () => {
    const token = getSecureItem("token");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(
      BaseUrl + `/loan/getLoanApplicationDetails?loanId=${selectedLoan?.value}`,
      {
        headers: headers,
      }
    )
      .then((resp) => {
        if (resp.status == 200) {
          setPdfData(resp.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLoanApplicationCustomer = async () => {
    const token = getSecureItem("token");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(
      BaseUrl +
        `/loan/getLoanApplicationCustomer?customerId=${selectedCustomer?.value}`,
      {
        headers: headers,
      }
    )
      .then((resp) => {
        if (resp.status == 200) {
          setPdfData(resp.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getLoanAgreementDetails = async () => {
    const token = getSecureItem("token");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(
      BaseUrl + `/loan/getLoanAgreementDetails?loanId=${selectedLoan?.value}`,
      {
        headers: headers,
      }
    )
      .then((resp) => {
        if (resp.status == 200) {
          setPdfData(resp.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getPromissoryNote = async () => {
    const token = getSecureItem("token");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(
      BaseUrl +
        `/customer/getPromissoryNote?customerId=${selectedCustomer?.value}&loanId=${selectedLoan?.value}`,
      {
        headers: headers,
      }
    )
      .then((resp) => {
        if (resp.status == 200) {
          setPdfData(resp.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllLoans = async () => {
    const token = getSecureItem("token");
    const companyId = getSecureItem("loggedinUserCompany");

    const headers = {
      Authorization: "Bearer " + token,
    };

    Axios.get(
      BaseUrl +
        `/loan/getLoansforCustomers?customerId=${selectedCustomer?.value}&companyId=${companyId}&onlyClosed=${selectedDocType?.value === '6' ? true : false}`,
      {
        headers: headers,
      }
    )
      .then((resp) => {
        if (resp.status == 200) {
          const loanIds = resp.data?.map((item) => ({
            label: item.loanId,
            value: item.loanId,
          }));
          setLoanData(loanIds);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const headers = {
        Authorization: "Bearer " + token,
      };

      const { data } = await Axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser.companyId },
        headers,
      });

      const branchData = loggedinUser?.userType == "superAdmin" ? data?.data : data?.data?.filter((item) => item?.branchId == loggedinUser?.branchId);

      const formattedBranches = (branchData || []).map(item => ({
        label: item.branchName,
        value: item.branchId,
        address: item.branchAddress,
      }));

      setBranchData([
        { label: "Select Branch", value: null },
        ...formattedBranches,
      ]);
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  useEffect(() => {
    getAllCustomers();
  }, [selectedBranch]);

  useEffect(() => {
    if (selectedCustomer) {
      getAllLoans();
    }
  }, [selectedCustomer]);

  useEffect(() => {
    setPdfData([]);
    if (selectedDocType && selectedCustomer) {
      if (selectedDocType?.value === "1") {
        if (selectedLoan) {
          getLoanApplicationDetails();
        } else {
          getLoanApplicationCustomer();
        }
      } else if (
        selectedDocType?.value === "2" ||
        selectedDocType?.value === "3" ||
        selectedDocType?.value === "4" ||
        selectedDocType?.value === "6"
      ) {
        if (selectedLoan) {
          getLoanAgreementDetails();
        }
      } else if (selectedLoan) {
        getPromissoryNote();
      }
    }
  }, [selectedCustomer, selectedLoan]);

  const handleDocTypeChange = useCallback((val) => {
    setSelectedDocType(val);
    setSelectedCustomer(null);
    setSelectedLoan(null);
    setRenderedComponent(null);
  }, []);

  const handleCustomerChange = useCallback((val) => {
    setSelectedCustomer(val);
    setSelectedLoan(null);
  }, []);

  const handleLoanChange = useCallback((val) => {
    setSelectedLoan(val);
  }, []);

  const handleBranchChange = useCallback((val) => {
    setSelectedBranch(val);
    setSelectedCustomer(null);
  }, []);

  const handleReset = () => {
    setSelectedDocType(null);
    setSelectedBranch(null);
    setSelectedCustomer(null);
    setSelectedLoan(null);
    setRenderedComponent(null);
  };

  const handleSubmit = () => {
    if (selectedDocType && selectedCustomer) {
      if (selectedDocType.value === "1") {
        if (selectedLoan) {
          setRenderedComponent(
            <LoanApplication branchAddress={selectedBranch?.address} data={pdfData} printRef={printRef} signatureType={signatureType} />
          );
        } else {
          setRenderedComponent(
            <LoanApplication branchAddress={selectedBranch?.address} data={pdfData} printRef={printRef} signatureType={signatureType} />
          );
        }
      } else if (selectedLoan) {
        if (selectedDocType.value === "2") {
          setRenderedComponent(
            <LoanAgreement
              branchAddress={selectedBranch?.address}
              data={pdfData}
              printRef={printRef}
              noOfLoans={noOfLoans}
              language={selectedLanguage?.value}
              signatureType={signatureType}
            />
          );
        } else if (selectedDocType.value === "3") {
          setRenderedComponent(
            <LoanSanctionLetter branchAddress={selectedBranch?.address} data={pdfData} printRef={printRef} language={selectedLanguage?.value} signatureType={signatureType} />
          );
        } else if (selectedDocType.value === "4") {
          setRenderedComponent(<EmiCard branchAddress={selectedBranch?.address} data={pdfData} printRef={printRef} noOfLoans={noOfLoans} language={selectedLanguage?.value} signatureType={signatureType} />);
        } else if (selectedDocType.value === "5"){
          setRenderedComponent(
            <DemandPromissoryNote branchAddress={selectedBranch?.address} data={pdfData} printRef={printRef} language={selectedLanguage?.value} signatureType={signatureType} />
          );
        } else if (selectedDocType.value === "6") {
          setRenderedComponent(<NoObjectionCertificate selectedBranch={selectedBranch} branchAddress={selectedBranch?.address} data={pdfData} printRef={printRef} noOfLoans={noOfLoans} language={selectedLanguage?.value} signatureType={signatureType} />);
        } else  {
          setRenderedComponent(<></>)
          // setRenderedComponent(<LoanReport data={pdfData} printRef={printRef} noOfLoans={noOfLoans} />);
        }
      }
    }
  };

  return (
    <>
      <Sidebar />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="paddingSidebar"
      >
        <img src={companylogo} alt="logo" />
      </Stack>

      <Stack spacing={1} className="paddingSidebar">
        <Box
          className="print-docs"
          sx={{
            width: "70%",
            paddingInline: "10px",
            paddingTop: "20px",
            backgroundColor: "#fff",
          }}
        >
          <Grid container alignItems="center">
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Document Type</strong>
                <Select
                  options={docTypes}
                  value={selectedDocType}
                  onChange={handleDocTypeChange}
                  placeholder="Select Document Type"
                />
              </Stack>
            </Grid>
            {(selectedDocType?.value == "2" || selectedDocType?.value == "4"
              //  || selectedDocType?.value == "6"
               ) && <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Enter the number of records to display per page(Max: 40)</strong>
                <input
                  type="number"
                  min={1}
                  max={40}
                  value={noOfLoans}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    if (!isNaN(value) && value >= 1 && value <= 40) {
                      setNoOfLoans(value);
                    } else if (e.target.value === "") {
                      setNoOfLoans("");
                    }
                  }}
                  style={{
                    border: '0.5px solid gray',
                    height: '15px',
                    fontSize: '15px',
                    padding: '10px',
                    borderRadius: '5px',
                  }}
                />
              </Stack>
            </Grid>}
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Branches</strong>
                <Select
                  options={branchData}
                  value={selectedBranch}
                  isDisabled={(loggedinUser?.company?.planId == 3) ? false : true}
                  onChange={handleBranchChange}
                  placeholder="Select Branch"
                />
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Customers</strong>
                <Select
                  options={customerData}
                  isDisabled={!selectedDocType}
                  value={selectedCustomer}
                  onChange={handleCustomerChange}
                  placeholder="Select Customer"
                />
              </Stack>
            </Grid>
            {(selectedDocType?.value !== "1" && countryCode == '91') && (
              <Grid item xs={12} sx={{ padding: "0 10px" }}>
                <Stack spacing={0.5} marginBottom={2}>
                  <strong>Languages</strong>
                  <Select
                    options={selectedDocType?.value == "6" ? languages2 : languages}
                    value={selectedLanguage}
                    onChange={(val) => setSelectedLanguage(val)}
                    placeholder="Select Language"
                  />
                </Stack>
              </Grid>
            )}
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Loans</strong>
                <Select
                  options={loanData}
                  isDisabled={!selectedCustomer}
                  value={selectedLoan}
                  onChange={handleLoanChange}
                  placeholder="Select Loan"
                />
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ padding: "0 10px" }}>
              <Stack spacing={0.5} marginBottom={2}>
                <strong>Signature Option</strong>
                <RadioGroup
                  row
                  value={signatureType ? "default" : "manual"}
                  onChange={(e) => setSignatureType(e.target.value === "default")}
                >
                  <FormControlLabel
                    value="default"
                    control={<Radio />}
                    label="Use Default Stored Signature"
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: '13px',
                        fontFamily: 'Lato',
                        whiteSpace: 'nowrap',
                      },
                    }}
                  />
                  <FormControlLabel
                    value="manual"
                    control={<Radio />}
                    label="Custom Signature"
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: '13px',
                        fontFamily: 'Lato',
                        whiteSpace: 'nowrap',
                      },
                    }}
                  />
                </RadioGroup>
              </Stack>
            </Grid>
            <Grid item xs={12} sx={{ padding: "0 10px", marginBottom: "20px" }}>
              <Stack direction="row" spacing={5} alignItems="center">
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  startIcon={<RestoreOutlined />}
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<ViewList />}
                  onClick={handleSubmit}
                  disabled={
                    selectedDocType && selectedCustomer
                      ? selectedDocType.value === "1" || selectedLoan
                        ? false
                        : true
                      : true
                  }
                >
                  Show PDF
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Stack>

      {/* Render the selected component */}
      {renderedComponent && (
        <Box ref={printRef} className="paddingSidebar">
          {renderedComponent}
        </Box>
      )}

      <div
        style={{ display: "flex", justifyContent: "center", marginBlock: 10 }}
      >
        <Button
          variant="outlined"
          style={{ minWidth: 200, marginBottom: "20px" }}
          startIcon={<Print />}
          onClick={handlePrint}
          disabled={!renderedComponent}
        >
          Print
        </Button>
      </div>
    </>
  );
};

export default PrintDocs;
